import { render, staticRenderFns } from "./scenePc.vue?vue&type=template&id=35c871e9&scoped=true&"
import script from "./scenePc.vue?vue&type=script&lang=js&"
export * from "./scenePc.vue?vue&type=script&lang=js&"
import style0 from "./scenePc.vue?vue&type=style&index=0&id=35c871e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c871e9",
  null
  
)

export default component.exports